// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";
// MARK: Components
import CSSTypography from ".";
import CSSStyles from "enums/cssStyles";
// MARK: Styled Components
interface ContainerProps {
  margin: number;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  margin-top: ${({ margin }) => margin}px;
`;

// MARK: React Component
// Props
interface Props {
  copy: string;
}
// Styleguide & Datapoints
const getDatapoints = (styleguide: ReduxStyleguide) => {
  const { colors } = styleguide;
  const { primary } = colors;
  return {
    style: CSSStyles.medium,
    color: primary,
  };
};
// Component
const Description = ({ copy }: Props) => {
  // MARK: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );
  // MARK: Variables
  const { margin } = styleguide;
  const { color, style } = getDatapoints(styleguide);

  // MARK: Render
  return (
    <Container margin={margin}>
      <CSSTypography
        type={"h2"}
        className={style}
        color={color}
        textAlign={"left"}
        formatCopy
        dangerouslySetInnerHTML
      >
        {copy}
      </CSSTypography>
    </Container>
  );
};

export default Description;
